enum Size {
  Smallest = '1rem',
  Small = '1.4rem',
  Default = '1.8rem',
  Medium = '2.4rem',
  Large = '3.6rem',
  Largest = '5.6rem',
}

export default Size;
